import { DAY_UNITS, PTO_FIXED_DATE_TYPE } from '../constants';
import { formatDate, getRealDate } from '../utils';

export function getLeaveTypeUsed(type, leavesStatus = {}) {
  const userLeaves = leavesStatus[type.id];

  if (!userLeaves) {
    return 0;
  }

  if (!type.paid) {
    return userLeaves.unpaid || 0;
  }

  return userLeaves.paid || 0;
}

export function getCapForType(type, { userCaps = {}, useGlobal = false, globalCap = null }) {
  if (useGlobal) {
    const cap = userCaps?.global?.cap;
    return cap || cap === 0 ? cap : globalCap;
  }

  const typeCap = userCaps && userCaps[String(type.id)];
  return typeCap && (typeCap.cap || typeCap.cap === 0) ? typeCap.cap : type.cap;
}

export function getDecimalLabel(usage, { leaveCapUnit, workDayMinutes, daysUnit = DAY_UNITS }) {
  if (!usage) {
    return '0';
  }

  if (leaveCapUnit === daysUnit) {
    return `${Math.round((usage / workDayMinutes) * 100) / 100}`;
  }

  return `${Math.round((usage / 60) * 100) / 100}`;
}

export function getTimeOffYear({ date, hireDate, leaveResetType, leaveResetDate }) {
  const leaveDateString = leaveResetType === PTO_FIXED_DATE_TYPE ? leaveResetDate : hireDate;
  const eventYear = date.getFullYear();
  if (!leaveDateString) {
    return eventYear;
  }

  const resetDate = getRealDate(leaveDateString);
  resetDate.setFullYear(eventYear);

  return resetDate > date && formatDate(resetDate) !== formatDate(date) ? eventYear - 1 : eventYear;
}

export function computeRemainingDays(usedMinutes, minutesInDay) {
  const remainingMinutes = usedMinutes / minutesInDay;
  return Math.sign(remainingMinutes) * Math.floor(Math.abs(remainingMinutes));
}
